import React, { memo } from "react";
import { MDSProgressBar, MDSProgressBarColor } from "@/mds/components/loading/progress-bar";
import { motion, AnimatePresence } from "motion/react";
import styled from "@emotion/styled";

type Props = {
  isPaused: boolean;
  durationMs: number;
  onComplete: () => void;
  className?: string;
};

export const MDSSessionCountdownTimer: React.FC<Props> = memo(
  ({ isPaused, durationMs, onComplete, className }) => {
    return (
      <ProgressContainer className={className}>
        <AnimatePresence>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
          >
            <MDSProgressBar
              aria-label="Saving to Mem"
              color={MDSProgressBarColor.Brand}
              animation={{
                direction: "decrease",
                duration: durationMs,
                paused: isPaused,
                onComplete: onComplete,
              }}
            />
          </motion.div>
        </AnimatePresence>
      </ProgressContainer>
    );
  }
);

const ProgressContainer = styled.div`
  position: absolute;
  top: 0px;
  left: 0;
  width: 100%;
  height: 10px;
  z-index: 10;
`;
